import React, {useState} from 'react'
import { Chip } from '@mui/material'
import { ExclusionType } from 'src/types/SchoolType'
import { excludedType } from 'src/types/UserType'
import CloseIcon from "@mui/icons-material/Close";

interface Props{
  highschoolInfo?: excludedType[]
  universityInfo?: excludedType[]
  isModify: boolean
  setTempExcludedInfo :React.Dispatch<React.SetStateAction<ExclusionType[]>>
}

const Excluded = ({highschoolInfo,universityInfo, isModify, setTempExcludedInfo}:Props) => {
    const [excludedToRemove, setExcludedToRemove] = useState<ExclusionType[]>([]);
    if(excludedToRemove){} // EsLint 방지용

    const handleExclude = ({school_class,school_id,excluded}:ExclusionType)=>{
      const newExclusion = { school_class, school_id, excluded };
    
      // 2. 서버 요청용 데이터 저장
      setExcludedToRemove((prev) => {
        const next = [...prev, newExclusion];
        setTempExcludedInfo(next); // ✅ ref 동기화
        return next;
      });
    }

  return (
    <div>
      {highschoolInfo
      ?.filter((school) => !excludedToRemove.some(e => e.school_id === school.id)) // ❗숨긴 항목은 제외
      .map((school) => (
        <Chip
          key={school.id}
          label={school.name}
          {...(!isModify && {
            onDelete: () =>
              handleExclude({
                school_class: school.name,
                school_id: school.id,
                excluded: false,
              }),
            deleteIcon: <CloseIcon />,
          })}
          sx={{ backgroundColor: 'rgba(245,245,245,1)', margin: '5px' }}
        />
      ))}
      {universityInfo
      ?.filter((school) => !excludedToRemove.some(e => e.school_id === school.id)) // ❗숨긴 항목은 제외
      .map((school) => (
        <Chip
          key={school.id}
          label={school.name}
          {...(!isModify && {
            onDelete: () =>
              handleExclude({
                school_class: school.name,
                school_id: school.id,
                excluded: false,
              }),
            deleteIcon: <CloseIcon />,
          })}
          sx={{ backgroundColor: 'rgba(245,245,245,1)', margin: '5px' }}
        />
      ))}
    </div>
  )
}

export default Excluded